import { render, staticRenderFns } from "./dietary_preferences.vue?vue&type=template&id=542813e9&scoped=true&lang=html&"
import script from "./dietary_preferences.vue?vue&type=script&lang=js&"
export * from "./dietary_preferences.vue?vue&type=script&lang=js&"
import style0 from "./dietary_preferences.vue?vue&type=style&index=0&id=542813e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542813e9",
  null
  
)

export default component.exports